/* eslint-disable @reatom/unit-naming-rule */
import { action, atom, onConnect, reaction, sleep } from '@reatom/framework'

import { AsyncStateN } from '@blade/std-lib'
import { selectedNetworkAtom } from '@root/entities/network'
import { reatomRequest } from '@root/shared/lib'

import { referralCheckAvailabilityRequestAction } from './referral-code-requests'

import type { ReferralCode } from '@root/entities/referral'

export const reatomCheckCodeAvailability = ({
  currentReferralCode,
}: {
  currentReferralCode: ReferralCode | undefined
}) => {
  const referralCodeAtom = atom<ReferralCode | undefined>(
    currentReferralCode,
    'referralCodeAtom',
  )

  const checkAvailabilityRequestAtom = reatomRequest({
    execAction: action(
      async (
        ctx,
        req: {
          referralCode: ReferralCode
        },
      ) => {
        await ctx.schedule(() => sleep(500))
        const result = await ctx.schedule(() =>
          referralCheckAvailabilityRequestAction(ctx, {
            ...req,
            network: ctx.get(selectedNetworkAtom),
          }),
        )

        return result
      },
      'formRequestAtom.execAction',
    ),
  })

  const changeReaction = reaction(async (ctx) => {
    const referralCode = ctx.spy(referralCodeAtom)
    if (referralCode === currentReferralCode) {
      checkAvailabilityRequestAtom.setState(ctx, AsyncStateN.notInitiated())
      return
    }
    if (referralCode) {
      await ctx.schedule(() => sleep(300))
      checkAvailabilityRequestAtom.execute(ctx, { referralCode })
    }
  })

  onConnect(checkAvailabilityRequestAtom, (ctx) => {
    const changeReactionResult = changeReaction(ctx)
    return () => {
      changeReactionResult.unsubscribe()
    }
  })

  return {
    referralCodeAtom,
    checkAvailabilityState: checkAvailabilityRequestAtom,
    checkAvailability: checkAvailabilityRequestAtom.execute,
  }
}
